<input
  *yatVar="language$ | async as language"
  [(ngModel)]="value"
  [class.ng-invalid]="isInvalid"
  inputmode="numeric"
  spellcheck="false"
  [specialCharacters]="['.', '/']"
  [dropSpecialCharacters]="false"
  yatInput
  maxlength="12"
  [mask]="language === 'de' ? '00.00.0000' : '00/00/0000'"
  [showMaskTyped]="showMask"
  [placeHolderCharacter]="language === 'de' ? 'TT.MM.JJJJ' : 'dd/mm/yyyy'"
  (ngModelChange)="onInputChange($event)"
  (blur)="handleBlur(value)"
  (focus)="handleFocus()" />
